import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import _clamp from 'lodash/clamp';

import { schedulePropTypes } from 'constants/propTypes';
import { classNameWithModifiers as withMods } from 'helpers/class-name';
import { useRefEffect, useWindowScrollPos } from 'helpers/react-hooks';
import Message from 'components/Message';
import { TodayTomorrowWeekday } from 'components/IntlHelpers';

import { headerMobileMessages as messages } from './ScheduleDetail.messages';
import './ScheduleDetailHeaderMobile.scss';

const SCROLL_RANGE_START = 25;
const SCROLL_RANGE_STOP = 50;

function scaleToRange(value, rangeMin, rangeMax, scaleMin, scaleMax) {
  const clampedValue = _clamp(value, rangeMin, rangeMax);
  return Math.round(((clampedValue - rangeMin) / (rangeMax - rangeMin)) * (scaleMax - scaleMin) + scaleMin);
}

function ScheduleDetailHeaderMobile({ schedule }) {
  const { isInThePast, scheduleName, startDateTime } = schedule;
  const [timeAndDateHeight, setTimeAndDateHeight] = useState(0);
  const [scheduleNameHeight, setScheduleNameHeight] = useState(0);
  const timeAndDateRef = useRefEffect(node => setTimeAndDateHeight(node.offsetHeight));
  const scheduleNameRef = useRefEffect(node => setScheduleNameHeight(node.offsetHeight));
  const [appHeaderHeight] = useState(() => {
    const style = window.getComputedStyle(document.documentElement);
    const appHeaderSize = style.getPropertyValue('--app-header-size');
    return parseInt(appHeaderSize, 10);
  });
  const timeAndDateMax = Math.floor(
    (appHeaderHeight - timeAndDateHeight) / 2 - (appHeaderHeight - (timeAndDateHeight + scheduleNameHeight)) / 2
  );
  const [, scrollY] = useWindowScrollPos();
  const isScrolled = scrollY > SCROLL_RANGE_START + (SCROLL_RANGE_STOP - SCROLL_RANGE_START) / 2;
  const timeAndDatePos = scaleToRange(scrollY, SCROLL_RANGE_START, SCROLL_RANGE_STOP, timeAndDateMax, 0);
  const scheduleNamePos = scaleToRange(scrollY, SCROLL_RANGE_START, SCROLL_RANGE_STOP, 100, 0);

  return (
    <>
      <Helmet>
        <body className={isScrolled && 'body__sticky-controls--is-scrolled'} />
      </Helmet>
      <div className="schedule-detail-header-mobile">
        <span className="schedule-detail-header-mobile__flex-wrapper">
          <span
            ref={timeAndDateRef}
            className={withMods('schedule-detail-header-mobile__time-and-date', { isInThePast, isScrolled })}
            style={{ transform: `translateY(${timeAndDatePos}px)` }}>
            <Message
              message={messages.timeAndDate}
              values={{
                dateTime: startDateTime,
                relative: <TodayTomorrowWeekday date={startDateTime} />,
              }}
            />
          </span>
        </span>
        <span className="schedule-detail-header-mobile__flex-wrapper">
          <span
            ref={scheduleNameRef}
            className="schedule-detail-header-mobile__schedule-name"
            style={{ transform: `translateY(${scheduleNamePos}%)` }}
            title={scheduleName}>
            {scheduleName}
          </span>
        </span>
      </div>
    </>
  );
}

ScheduleDetailHeaderMobile.propTypes = {
  ...schedulePropTypes,
};

export default ScheduleDetailHeaderMobile;
